/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Tlm_2Inputs */

const en_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`structured_data`)
};

const ar_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات منظمة`)
};

const bn_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাঠামোগত ডেটা`)
};

const de_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturierte Daten`)
};

const es_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos estructurados`)
};

const fr_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données structurées`)
};

const pt_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados estruturados`)
};

const zh_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化数据`)
};

const tr_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapısal veri`)
};

const ru_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Структурные данные`)
};

const pl_svc_programmatic_seo_tlm_2 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane strukturalne`)
};

/**
* | output |
* | --- |
* | "structured_data" |
*
* @param {Svc_Programmatic_Seo_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_tlm_2 = /** @type {((inputs?: Svc_Programmatic_Seo_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "de") return de_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "es") return es_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_tlm_2(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_tlm_2(inputs)
	return en_svc_programmatic_seo_tlm_2(inputs)
});
export { svc_programmatic_seo_tlm_2 as "svc_programmatic-seo_tlm_2" }